import React from "react";
import styles from "./MakeModelCell.module.css";
import {OfferInListDTO} from "../../../../../../../api/generated";

interface MakeModelCellProps {
    offer: OfferInListDTO
}

export const MakeModelCell: React.FC<MakeModelCellProps> = ({offer}) => {

    const getMake = () => {
        const make = offer.make;
        if (make === "*") {
            return "All Makes";
        }
        return make;
    }
    const getModel = () => {
        const model = offer.model;
        if (model === "*") {
            return "All Models";
        }
        return model;
    }

    return <div className={styles.wrapper}>
        <span className={styles.make}>{getMake()}</span>
        {offer.make !== "*" && <span className={styles.model}>{getModel()}</span>}
    </div>
}
